// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"mfa-code__wrapper--3I8XX"};